"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const bmk_ui_framework_1 = require("@biomemakers/bmk_ui_framework");
const TabularAnalyticsController_1 = __importDefault(require("./modules/controllers/TabularAnalyticsController"));
const lucide_vue_next_1 = require("lucide-vue-next");
const FieldsHeading_vue_1 = __importDefault(require("@becrop/components/TabularAnalytics/components/FieldsHeading.vue"));
const TabularPreSet_vue_1 = __importDefault(require("@becrop/components/TabularAnalytics/components/TabularPreSet.vue"));
const TabularActions_vue_1 = __importDefault(require("@becrop/components/TabularAnalytics/components/TabularActions.vue"));
const CropLabel_vue_1 = __importDefault(require("@becrop/components/TabularAnalytics/components/CropLabel.vue"));
const PolygonGeodata_vue_1 = __importDefault(require("@becrop/components/TabularAnalytics/components/PolygonGeodata.vue"));
const RankTag_vue_1 = __importDefault(require("@becrop/components/TabularAnalytics/components/RankTag.vue"));
const FarmActions_vue_1 = __importDefault(require("@becrop/components/TabularAnalytics/components/FarmActions.vue"));
const FieldActions_vue_1 = __importDefault(require("@becrop/components/TabularAnalytics/components/FieldActions.vue"));
const PaginationProgress_vue_1 = __importDefault(require("@becrop/components/TabularAnalytics/components/PaginationProgress.vue"));
const FieldsTable_vue_1 = __importDefault(require("@becrop/components/TabularAnalytics/components/FieldsTable.vue"));
const FarmsTable_vue_1 = __importDefault(require("./components/FarmsTable.vue"));
const RecommendationsLegend_vue_1 = __importDefault(require("./components/RecommendationsLegend.vue"));
const MixpanelHandler_1 = __importDefault(require("@becrop/components/Modules/Common/Models/MixpanelHandler"));
let TabularAnalytics = class TabularAnalytics extends vue_property_decorator_1.Vue {
    constructor() {
        /* font-weight: 900;
        letter-spacing: .8px;
        font-size: 16px; */
        super(...arguments);
        this.mixpanelHandler = new MixpanelHandler_1.default();
        this.TABULAR_ANALYTICS_CONTROLLER = TabularAnalyticsController_1.default.getInstance();
        this.farms = [];
        this.fakeFinished = false;
        this.fakeCurrentPage = 0;
        this.fakeTotalPages = 5;
        this.intervalId = null;
        this.tabularMode = 'farms'; //farms, fields
        this.selectFarm = this.farmsArray[0];
        this.showTooltip = false;
        this.progress = 0;
        this.intervalIdLoading = null;
    }
    get extensionUnit() {
        const unit = this.TABULAR_ANALYTICS_CONTROLLER.configuration.unit.includes('h') ? 'hectares' : 'acres';
        return unit;
    }
    get isBiome() {
        return (this.data.user.role === 1 || this.data.user.biome_level > 0) ? true : false;
    }
    get loading() {
        return this.TABULAR_ANALYTICS_CONTROLLER.loadingAllPagesFarms;
    }
    toggleLegend() {
        this.showTooltip = !this.showTooltip;
    }
    startFakeProgress() {
        if (this.intervalIdLoading) {
            clearTimeout(this.intervalIdLoading);
        }
        this.progress = 0;
        const tick = () => {
            if (this.progress < 90) {
                const increment = 1 + Math.floor(Math.random() * 5);
                this.progress = Math.min(this.progress + increment, 90);
                this.intervalIdLoading = setTimeout(tick, 500 + Math.random() * 1000);
            }
        };
        tick();
    }
    get loadingFields() {
        var _a;
        if (this.TABULAR_ANALYTICS_CONTROLLER.tabularMode === 'fields') {
            if (this.TABULAR_ANALYTICS_CONTROLLER.selectedFarm) {
                return (_a = this.TABULAR_ANALYTICS_CONTROLLER.selectedFarm) === null || _a === void 0 ? void 0 : _a.loadingAllPagesFields;
            }
        }
        else {
            return false;
        }
    }
    updateLoading() {
        if (this.TABULAR_ANALYTICS_CONTROLLER.loadingAllPagesFarms || this.loadingFields) {
            this.startFakeProgress();
        }
        else {
            this.finishFakeProgress();
        }
    }
    finishFakeProgress() {
        if (this.intervalId) {
            clearInterval(this.intervalId);
            this.intervalId = null;
        }
        // Llena al 100% rápidamente
        this.progress = 100;
        // Opcional: esconder la barra luego de un breve delay
        setTimeout(() => {
            this.progress = 0;
        }, 500);
    }
    get clientName() {
        const farm = this.TABULAR_ANALYTICS_CONTROLLER.farms[0];
        const name = farm === null || farm === void 0 ? void 0 : farm.client_name;
        const code = farm === null || farm === void 0 ? void 0 : farm.client_code;
        return `${name} (${code})`;
    }
    launchCrumb(slug) {
        switch (slug) {
            case 'home':
                window.location.href = '/dashboard';
                break;
            case 'analytics':
                this.TABULAR_ANALYTICS_CONTROLLER.tabularMode = 'farms';
                this.tabularMode = 'farms';
                this.TABULAR_ANALYTICS_CONTROLLER.updatedSearchCriteria('');
                break;
        }
    }
    togglePreset(p) {
        if (!this.TABULAR_ANALYTICS_CONTROLLER.configuration.isPresetActive(p)) {
            this.mixpanelHandler.trackEvent('tabularPreset', {
                preset: p,
                level: this.TABULAR_ANALYTICS_CONTROLLER.tabularMode,
            });
        }
        this.TABULAR_ANALYTICS_CONTROLLER.configuration.isPresetActive(p) ? this.toggle(p, false) : this.toggle(p, true);
    }
    toggle(a, b) {
        const keys = ['recommendations', 'needs', 'metrics', 'phch_metrics'];
        // Marcar el nodo activo y sus hijos
        this.TABULAR_ANALYTICS_CONTROLLER.configuration.columnManager.updateNode(this.TABULAR_ANALYTICS_CONTROLLER.configuration.columnManager.tree, a, b);
        this.TABULAR_ANALYTICS_CONTROLLER.configuration.columnManager.setChildrenChecked(a, b);
        if (b && keys.includes(a)) {
            this.TABULAR_ANALYTICS_CONTROLLER.configuration.setPreset(a);
        }
        else {
            this.TABULAR_ANALYTICS_CONTROLLER.configuration.unsetPreset(a);
        }
        // Desactivar el resto de ramas si se activó una
        if (b) {
            keys.forEach((preset) => {
                if (preset !== a) {
                    this.TABULAR_ANALYTICS_CONTROLLER.configuration.unsetPreset(preset);
                    this.TABULAR_ANALYTICS_CONTROLLER.configuration.columnManager.updateNode(this.TABULAR_ANALYTICS_CONTROLLER.configuration.columnManager.tree, preset, false);
                }
            });
        }
    }
    async mounted() {
        await this.TABULAR_ANALYTICS_CONTROLLER.getFarmAnalytics();
        this.farms = this.TABULAR_ANALYTICS_CONTROLLER.getAllFarms();
        this.TABULAR_ANALYTICS_CONTROLLER.switchExtensionUnits('ha');
        this.intervalId = setInterval(() => {
            if (this.fakeCurrentPage == this.fakeTotalPages) {
                this.fakeFinished = true;
                clearInterval(this.intervalId);
            }
            else {
                this.fakeCurrentPage = this.fakeCurrentPage + 1;
            }
        }, 2000);
    }
    get farmsArray() {
        return this.TABULAR_ANALYTICS_CONTROLLER.getAllFarms();
    }
    updateFarms() {
        this.farms = this.farmsArray;
    }
    beforeUnmount() {
        if (this.intervalId) {
            clearInterval(this.intervalId);
        }
    }
    async seeDetails(newMode, farmId) {
        this.tabularMode = newMode;
        this.TABULAR_ANALYTICS_CONTROLLER.updatedSearchCriteria('');
        this.TABULAR_ANALYTICS_CONTROLLER.tabularMode = newMode;
        this.selectFarm = this.TABULAR_ANALYTICS_CONTROLLER.getAllFarms().find(farm => farm.id === farmId);
        this.TABULAR_ANALYTICS_CONTROLLER.updatedSelectFarm(this.selectFarm);
        await this.selectFarm.getFields();
        /*  this.TABULAR_ANALYTICS_CONTROLLER.configuration.preSets.forEach((preset: PresetType) =>{
             if(this.TABULAR_ANALYTICS_CONTROLLER.configuration.isPresetActive(preset)){
                 this.TABULAR_ANALYTICS_CONTROLLER.configuration.unsetPreset(preset)
             }
         }) */
        this.TABULAR_ANALYTICS_CONTROLLER.switchExtensionUnits('ha');
        this.progress = 0;
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)()
], TabularAnalytics.prototype, "data", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('TABULAR_ANALYTICS_CONTROLLER.loadingAllPagesFarms'),
    (0, vue_property_decorator_1.Watch)('loadingFields')
], TabularAnalytics.prototype, "updateLoading", null);
__decorate([
    (0, vue_property_decorator_1.Watch)('farmsArray')
], TabularAnalytics.prototype, "updateFarms", null);
TabularAnalytics = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            Separator: bmk_ui_framework_1.Separator, HomeIcon: bmk_ui_framework_1.HomeIcon, Breadcrumbs: bmk_ui_framework_1.Breadcrumbs, BreadcrumbsItem: bmk_ui_framework_1.BreadcrumbsItem, AdvancedTable: bmk_ui_framework_1.AdvancedTable,
            FieldsTable: FieldsTable_vue_1.default, Column: bmk_ui_framework_1.Column, ColumnGroup: bmk_ui_framework_1.ColumnGroup, Row: bmk_ui_framework_1.Row, DateStylized: bmk_ui_framework_1.DateStylized, MapPin: lucide_vue_next_1.MapPin,
            ArrowRight: lucide_vue_next_1.ArrowRight, FarmsTable: FarmsTable_vue_1.default, FieldsHeading: FieldsHeading_vue_1.default, TabularPreSet: TabularPreSet_vue_1.default, TabularActions: TabularActions_vue_1.default,
            CropLabel: CropLabel_vue_1.default, PolygonGeodata: PolygonGeodata_vue_1.default, RankTag: RankTag_vue_1.default, FarmActions: FarmActions_vue_1.default, FieldActions: FieldActions_vue_1.default, PaginationProgress: PaginationProgress_vue_1.default,
            Button: bmk_ui_framework_1.Button, HelpCircle: lucide_vue_next_1.HelpCircle, RecommendationsLegend: RecommendationsLegend_vue_1.default, Ribbon: bmk_ui_framework_1.Ribbon
        }
    })
], TabularAnalytics);
exports.default = TabularAnalytics;
